export default "__VITE_ASSET__DedDvFDk__"